<template>
  <div class="money" id="icons">
    <ul>
      <router-link tag="li" to="/transfer" class="border-right">
        <i class="iconfont">&#xe642;</i>
        <p>转账</p>
      </router-link>
      <router-link tag="li" to="/recharge">
        <i class="iconfont">&#xe64e;</i>
        <span>立即充值</span>
      </router-link>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'MeIcons'
}
</script>

<style scoped>
.money ul{ display: flex; justify-content: space-around; border-bottom: 12px solid #f1f1f1; font-size: 14px;}
.money li{ list-style-type: none; width: 50%; margin: 13px 0; display: flex; justify-content: center; align-items: center;}
.money a{ text-decoration: none; color: #000; display: flex; align-items: center;}
.money .iconfont{ font-size: 25px; margin-right: 5px; color: #ff9400;}
</style>



// WEBPACK FOOTER //
// src/pages/me/components/Icons.vue